import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUsersInclusive, usersAreLoaded } from '../../../../reducers/users';
import { getInvites } from '../../../../reducers/invites';
import Tabs from '../../../../components/tabs';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import UsersList from '../../lists/users';
import InvitesList from '../../lists/invites';

class AdminUsers extends React.Component {
    componentDidMount() {
        const { role, invites, users, usersRole, usersInclude, getUsersInclusive, getInvites } = this.props;
        const typesToFetch = ['client'];
        if (!users || !usersAreLoaded(role, usersRole, typesToFetch, usersInclude)) {
            getUsersInclusive(role, undefined, typesToFetch);
        }
        if (!invites) getInvites(role);
    }

    render() {
        const { users, invites, role, page } = this.props;
        if (!users || !invites) {
            return null;
        }

        let items = [];

        const nonWorkers = users.filter(user => user.account_type !== 'contractor');

        if (nonWorkers) {
            items = [...items, { title: <FormattedMessage {...messages.users} />, content: <UsersList users={nonWorkers} role={role} /> }];
        }
        if (invites) {
            items = [
                ...items,
                {
                    title: <FormattedMessage {...messages.invites} />,
                    content: <InvitesList invites={invites} role={role} />
                }
            ];
        }

        return <Tabs items={items} pageWide title={page.label} isPageTitle={true} />;
    }
}

const mapStateToProps = state => ({
    role: state.identity.role,
    users: state.users.list,
    usersRole: state.users.listRole,
    usersInclude: state.users.listInclude,
    invites: state.invites.list
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getUsersInclusive: getUsersInclusive,
            getInvites: getInvites
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AdminUsers);



// WEBPACK FOOTER //
// ./src/pages/users/tenants/admin/index.jsx